import {
    Button,
    Form,
    FormFooter,
    FormSection,
    NumberField,
    Page,
    toast
} from '@7shifts/sous-chef';
import { getContactsWithoutTicketReport } from 'api/reportsApi';
import { useFormik } from 'formik';
import { __ } from 'i18n/translate';
import { downloadCSVBlob } from 'utils/csv';

const DEFAULT_LIMIT = 1000;
const MAX_LIMIT = 10000;

type FormData = {
    limit: string;
};

const ContactsWithoutTicketPage = () => {
    const formik = useFormik<FormData>({
        initialValues: {
            limit: `${DEFAULT_LIMIT}`
        },
        onSubmit: (values, { setSubmitting }) => {
            const limit = Number.parseInt(values.limit, 10);

            if (!Number.isFinite(limit) || limit <= 0 || limit > MAX_LIMIT) {
                toast(
                    __('reportsPage.reportContactsWithoutTicketLimitError', {
                        max: MAX_LIMIT
                    }),
                    'danger'
                );
                return;
            }

            setSubmitting(true);
            getContactsWithoutTicketReport(limit)
                .then((data) => {
                    downloadCSVBlob(data, 'contatos-sem-ticket.csv');
                })
                .catch(() => {
                    toast('Something went wrong', 'danger');
                })
                .finally(() => formik.setSubmitting(false));
        }
    });

    return (
        <Page
            breadcrumbs={__('main.reports')}
            title={__('reportsPage.reportContactsWithoutTicket')}
            subtitle={__('reportsPage.reportContactsWithoutTicketDescription')}
        >
            <Form formik={formik}>
                <FormSection as="card">
                    <NumberField
                        name="limit"
                        value={formik.values.limit}
                        min={1}
                        max={MAX_LIMIT}
                        label={__(
                            'reportsPage.reportContactsWithoutTicketLimit'
                        )}
                        caption={__(
                            'reportsPage.reportContactsWithoutTicketLimitCaption',
                            { max: MAX_LIMIT }
                        )}
                        onChange={(value) =>
                            formik.setFieldValue('limit', value)
                        }
                    />
                </FormSection>
                <FormFooter
                    actions={{
                        primary: (
                            <Button type="submit" loading={formik.isSubmitting}>
                                {__('main.downloadCSV')}
                            </Button>
                        )
                    }}
                />
            </Form>
        </Page>
    );
};

export default ContactsWithoutTicketPage;
